import { HeartIcon } from '@heroicons/react/24/outline';
import { SubPageHeader } from '@/components/shared';
import { useAuth } from '@/contexts/AuthContext';
import { HealthPlanForm } from '../../components/HealthPlanForm';
import { OPEN_REQUEST_MESSAGE } from '../../components/HealthPlanForm/healthPlanForm.definitions';
import { useMyHealthPlanQuery } from '../../hooks/data/useDpRequestQueries';
import { DP_REQUESTS_PATH } from '../../routes';

export function HealthPlanPage() {
    const { user } = useAuth();
    const query = useMyHealthPlanQuery(Boolean(user?.email));

    return (
        <div className="mx-auto max-w-3xl space-y-6">
            <SubPageHeader
                backPlacement="end"
                backTo={DP_REQUESTS_PATH}
                icon={<HeartIcon className="h-6 w-6" aria-hidden="true" />}
                title="Benefícios: plano de saúde"
                description="Inclusão, mudança ou saída do plano de saúde, seu ou de dependentes."
            />

            {query.isPending && <div className="h-72 animate-pulse rounded-2xl bg-raro-gray-100" />}
            {query.isError && (
                <p className="rounded-2xl border border-rose-200 bg-rose-50 px-5 py-4 text-sm text-rose-800">
                    {query.error instanceof Error ? query.error.message : 'Não foi possível carregar seu plano.'}
                </p>
            )}
            {query.data?.hasOpenRequest && (
                <p className="rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4 text-sm text-amber-900">{OPEN_REQUEST_MESSAGE}</p>
            )}
            {query.data && !query.data.hasOpenRequest && <HealthPlanForm data={query.data} />}
        </div>
    );
}

export default HealthPlanPage;
